import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
  name: 'ordinal',
})
export class OrdinalNumberPipe implements PipeTransform {
  constructor() {}

  transform(v: number, noValue = ''): string {
    if (v === null || v === undefined) {
      return noValue;
    }
    const suffixes = ['th', 'st', 'nd', 'rd'];
    const vMod100 = v % 100;
    return v + (suffixes[(vMod100 - 20) % 10] || suffixes[vMod100] || suffixes[0]);
  }
}
